function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.8847 10.786L8.18884 9.88743V6.12996M15.3777 8.98882C15.3777 5.01854 12.1591 1.79999 8.18884 1.79999C4.21855 1.79999 1 5.01854 1 8.98882C1 12.9591 4.21855 16.1777 8.18884 16.1777C10.8497 16.1777 13.173 14.732 14.4159 12.5832M13.4056 8.19993L15.2028 9.99713L17 8.19993",
    stroke: "#F1F0F3",
    style: {
      stroke: "#F1F0F3",
      stroke: "color(display-p3 0.9451 0.9412 0.9529)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.c7e3684fab0601b9eb74f482748290d8.svg";
export { ForwardRef as ReactComponent };